import { forumThreadPolicy } from "@/policies";

(function (angular) {
  "use strict";

  angular.module("app").controller("forumCategoryController", forumCategory);

  forumCategory.$inject = [
    "$rootScope",
    "$scope",
    "ForumThreadsApi",
    "categoryPayload",
    "thisUser",
    "threadsPayload",
  ];

  function forumCategory(
    $rootScope,
    $scope,
    ForumThreadsApi,
    categoryPayload,
    thisUser,
    threadsPayload,
  ) {
    const vm = this;
    vm.limit = 9;

    // attributes
    vm.category = categoryPayload;
    vm.filters = {
      forum_category_id: categoryPayload.id,
      page: 1,
    };
    vm.isLoading = false;
    vm.orderFilters = {
      total_replies: {
        label: "Total Replies",
        order: "desc",
        sort: "total_replies",
      },
      last_activity_at: {
        label: "Latest",
        order: "desc",
        sort: "last_activity_at",
      },
    };
    vm.permissionChecks = {
      canCreateThread: forumThreadPolicy.canCreate(),
    };
    vm.selectedOrderFilter = vm.orderFilters.last_activity_at;
    vm.threads = threadsPayload;
    vm.user = thisUser;

    // methods
    vm.getThreads = getThreads;
    vm.orderThreads = orderThreads;

    /**
     * Initialises the controller.
     *
     * @returns {void}
     */
    function bootstrap(): void {
      $rootScope.$on("forum:updateThreads", getThreads);
    }

    /**
     * Get information about a specific thread, whether that's the data
     * about a thread, or the replies which it is getting.
     *
     * @param  {Number} id
     * @return {void}
     */
    function getThreads() {
      // Scroll to the top of the results
      const offset = $(".content-container.main").offset().top;
      window.scrollTo({ top: offset });

      vm.isLoading = true;
      ForumThreadsApi.get(
        vm.filters,
        (response) => {
          vm.threads = response;
          vm.isLoading = false;
        },
        (error) => {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Change the order of the threads and then call the API, to request
     * the new order.
     *
     * @return {void}
     */
    function orderThreads() {
      angular.merge(vm.filters, vm.selectedOrderFilter);
      delete vm.filters.label;
      vm.getThreads();
    }

    bootstrap();
    $scope.loadMore = function () {
      var increamented = vm.limit + 3;
      vm.limit =
        increamented > vm.threads.length ? vm.threads.length : increamented;
    };
  }
})(angular);
